import * as React from "react";
import type { SVGProps } from "react";

interface EmptyGoalProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const EmptyGoal = ({ cancelled = false, ...props }: EmptyGoalProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#FFF"
        d="M20.9 5.25c1.3 0 2.35 1.05 2.35 2.35v10.94c0 .69-.56 1.25-1.25 1.25h-.37c-.62 0-1.13-.45-1.23-1.04H3.6c-.1.55-.54.98-1.1 1.03H2c-.69 0-1.25-.55-1.25-1.24V7.6c0-1.3 1.05-2.35 2.35-2.35Z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M2.9 16.35v2.3a.5.5 0 0 1-.5.5h-.3a.5.5 0 0 1-.5-.5v-2.3c0-.28.22-.5.5-.5h.3c.28 0 .5.22.5.5m19.5.17v2.13a.5.5 0 0 1-.5.5h-.3a.5.5 0 0 1-.5-.5v-2.13c0-.27.22-.5.5-.5h.3c.28 0 .5.23.5.5m0-5v2.3a.5.5 0 0 1-.5.5h-.3a.5.5 0 0 1-.5-.5v-2.3c0-.27.22-.5.5-.5h.3c.28 0 .5.23.5.5m-19.5-.17v2.3a.5.5 0 0 1-.5.5h-.3a.5.5 0 0 1-.5-.5v-2.3c0-.28.22-.5.5-.5h.3c.28 0 .5.22.5.5M20.8 6.1l.5.1c.6.2 1.03.75 1.1 1.45V9c0 .18-.14.33-.32.33h-.65A.32.32 0 0 1 21.1 9V7.72a.35.35 0 0 0-.23-.3l-.3-.1a.5.5 0 0 1-.33-.45l-.01-.28a.48.48 0 0 1 .57-.5Zm-17 .48v.28a.5.5 0 0 1-.39.5l-.24.05a.35.35 0 0 0-.27.34v.9a.5.5 0 0 1-.5.5h-.3a.5.5 0 0 1-.5-.5v-.9c0-.78.54-1.44 1.29-1.61l.34-.05a.5.5 0 0 1 .57.49m4.94.02v.3a.5.5 0 0 1-.5.5h-2.3a.5.5 0 0 1-.5-.5v-.3c0-.28.22-.5.5-.5h2.3c.27 0 .5.22.5.5m5 0v.3a.5.5 0 0 1-.5.5h-2.3a.5.5 0 0 1-.5-.5v-.3c0-.28.22-.5.5-.5h2.3c.27 0 .5.22.5.5m5 0v.3a.5.5 0 0 1-.5.5h-2.3a.5.5 0 0 1-.5-.5v-.3c0-.28.22-.5.5-.5h2.3c.27 0 .5.22.5.5"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default EmptyGoal;
